import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { Button, Tooltip } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Play24Icon } from "@kaltura/ds-react-icons";
import { ButtonTextWrapper } from "../styled-components";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

interface JoinNowButtonProps {
    className?: string;
    entryName: string;
    onClick?: () => void;
    href?: string;
    disabled?: boolean;
    openInNewTab?: boolean;
}

/**
 * "Join Now" button for the session card.
 */
export const JoinNowButton = ({
    className = "",
    entryName,
    onClick,
    href,
    disabled,
    openInNewTab,
}: JoinNowButtonProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleClick = () => {
        sendButtonAnalytics("Session card - Join Now", ButtonClickAnalyticsType.LINK);
        onClick?.();
    };

    return (
        <Tooltip title={translate("Join Now - %1", [entryName])} placement={"bottom"}>
            <Button
                component={href ? "a" : "button"}
                color={"danger"}
                disabled={disabled}
                onClick={handleClick}
                href={href}
                target={openInNewTab ? "_blank" : undefined}
                startIcon={<Play24Icon />}
                className={`${className} kms-ds-event-list-item-button-join`}
                size={"large"}
                aria-label={translate("Join Button - %1", [entryName])}
            >
                <ButtonTextWrapper>{translate("Join Now")}</ButtonTextWrapper>
            </Button>
        </Tooltip>
    );
};
